import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseIncome} from '../case-income';
import {CaseIncomeService} from '../case-income.service';

@Component({
  selector: 'app-case-income-edit',
  templateUrl: 'edit.component.html',
})
export class CaseIncomeEditComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: CaseIncome;

  private givenCaseId: string;

  constructor(private readonly caseIncomeService: CaseIncomeService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string, model: CaseIncome): void {
    this.givenCaseId = caseId;
    this.model = model;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmEdit($event) {
    $event.preventDefault();
    this.disabled = true;
    this.caseIncomeService
      .updateCaseIncome(this.model.id, this.model, {
        parameters: { id: this.caseId },
      })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = undefined;
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
